import { ChevronLeft, ChevronRight } from "lucide-react";

// Centers the chevron icon within the nav button
const navIconBtnStyle = { display: "inline-flex", alignItems: "center", justifyContent: "center" };

// Custom toolbar: view buttons on the left, "< | Today | >" navigation on the right.
// Single-view calendars have no view buttons, so the label takes the left side instead.
const CalendarToolbar = ({ label, localizer: { messages }, onNavigate, onView, view, views }) => {
  const hasViewButtons = views.length > 1;

  return (
    <div className="rbc-toolbar">
      {hasViewButtons && (
        <span className="rbc-btn-group">
          {views.map((name) => (
            <button
              type="button"
              key={name}
              className={view === name ? "rbc-active" : ""}
              onClick={() => onView(name)}
            >
              {messages[name]}
            </button>
          ))}
        </span>
      )}
      <span
        className="rbc-toolbar-label"
        style={hasViewButtons ? undefined : { textAlign: "left", paddingLeft: 0 }}
      >
        {label}
      </span>
      <span className="rbc-btn-group" style={{ display: "inline-flex" }}>
        <button type="button" aria-label={messages.previous} onClick={() => onNavigate("PREV")} style={navIconBtnStyle}>
          <ChevronLeft size={16} aria-hidden="true" />
        </button>
        <button type="button" onClick={() => onNavigate("TODAY")}>
          {messages.today}
        </button>
        <button type="button" aria-label={messages.next} onClick={() => onNavigate("NEXT")} style={navIconBtnStyle}>
          <ChevronRight size={16} aria-hidden="true" />
        </button>
      </span>
    </div>
  );
};

export default CalendarToolbar;
